import script from "./SignalsList.vue?vue&type=script&setup=true&lang=js"
export * from "./SignalsList.vue?vue&type=script&setup=true&lang=js"

import "./SignalsList.vue?vue&type=style&index=0&id=6339d94b&lang=scss"

const __exports__ = script;

export default __exports__